/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, TextField } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import Trash from 'material-ui/svg-icons/action/delete';
import Agregar from 'material-ui/svg-icons/content/add-circle';
import FlatButton from 'material-ui/FlatButton';
import { List, ListItem } from 'material-ui/List';
import { blue500, yellow600 } from 'material-ui/styles/colors';
import ActionAssignment from 'material-ui/svg-icons/action/assignment';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';
import EditorInsertChart from 'material-ui/svg-icons/editor/insert-chart';
import { Info } from './components';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader, EmptyList } from '../../components/layout';
import { EditableInline, EditableInlineV2 } from '../../components/text';
import AutoComplete from 'material-ui/AutoComplete';
import { parsePath, getValueFromSelectList } from '../../common/helpers';
import { setValueIn } from '../../common/immutable';
import { DespachosFilter } from '../../components/filters';
import { serializeParams } from '../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../validations';
import Prefactura from '../../forms/customPrefactura';
import { preInvoice as preInvoiceService } from '../../services';
import { isEmpty } from 'lodash';
import {
    getPagePermissions,
    hasUpdatePermission,
    hasCreatePermission,
    hasReadPermission,
    REQUESTING_PAYMENT_PERMISSION,
    CUSTOMS_CLEARENCE_STATUSES_PERMISSION,
    ATTACHMENTS_PERMISSION,
    PRE_INVOICE_PERMISSION,
    CUSTOMS_CLEARENCE_PERMISSION
} from '../../security/permissions';
import { isExecutive } from '../../security/role.validator';
import Snackbar from 'material-ui/Snackbar';


class Despachos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            DisableSave: true
        };
    }

    componentWillMount() {
        const { userData: { userId } } = this.props;
        this.props.fetchData('despachos', 'customsClearences', 'customsClearences', { sort: 'arrivalTimestamp,desc', projection: 'customsClearenceInLine', ['customer.executiveUser.id']: isExecutive() ? userId : '' });
        this.props.fetchCustomsHousesForListing('customsHouses', 'customsHouses', 'customsHouses/search/findAllByOrderByNameAsc');
        this.props.fetchExecutiveUsersData('users', 'executiveUsers', 'users/search/findByRoleAndActive', { role: 'ROLE_EXECUTIVE', active: 'true' });
        this.props.fetchCustomer('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name' });
        this.props.fetchSupplier('suppliers', 'suppliers', 'suppliers?projection=denormalizedSupplier'); // CHECAR esto
        //this.props.fetchPreinvoice('preInvoice', 'preInvoices', 'preInvoices');
        this.props.fetchStatus('statuses', 'statuses', 'clearenceStatuses?projection=clearenceStatusProjection');
    }

    GotoSearch(params) {
        const { fetchData, userData: { userId } } = this.props;
        var newObject = {};
        Object.keys(params).forEach(key => params[key] === "" ? '' : newObject[key] = params[key]);
        delete newObject.customerText;
        delete newObject.supplierText;
        delete newObject.customsValueAux;
        delete newObject.minArrivalDate;
        delete newObject.maxArrivalDate;
        delete newObject.minRequestingDate;
        delete newObject.maxRequestingDate

        var ArrayURL = ""
        if (newObject.status.length === 0) {
          delete newObject.status
        }else {
            for(var i = 0; i < newObject.status.length; i++){
              ArrayURL = ArrayURL + "&status="+newObject.status[i];
              if (ArrayURL.includes(" ")) { ArrayURL = ArrayURL.replace(" ", "%20"); }
            }
            delete newObject.status
        }

        if (newObject.via.length === 0) { delete newObject.via }
        if (newObject.type.length === 0) { delete newObject.type }

        if (newObject.arrivalTimestamp != null) {
            newObject.arrivalTimestamp = newObject.arrivalTimestamp.replace(",", "ATS");
        }

        if (newObject.requestingPaymentTimestamp != null) {
            newObject.requestingPaymentTimestamp = newObject.requestingPaymentTimestamp.replace(",", "RPT");
        }


        if (newObject.customsValue != null) {
            if (newObject.customsValue.includes("Igual a,")) {
                newObject.customsValue = newObject.customsValue.replace("Igual a,", "");
            }

            if (newObject.customsValue.includes("Mayor que,")) {
                newObject.customsValue = newObject.customsValue.replace("Mayor que,", "");
                newObject.customsValue = newObject.customsValue.concat("MayQ")
            }

            if (newObject.customsValue.includes("Menor que,")) {
                newObject.customsValue = newObject.customsValue.replace("Menor que,", "MenQ");
            }
        }

        const useParams = {
            ...newObject,
            projection: 'customsClearenceInLine',
            ['customer.executiveUser.id']: isExecutive() ? userId : ''
        };
        fetchData('despachos', 'customsClearences', this.CreateURL('customsClearences', serializeParams(useParams).concat(ArrayURL), ''));

    }

    CreateURL(table, filter, projection) {

        if (filter.includes("customer=%2Fcustomer%2F")) { filter = filter.replace("customer=%2Fcustomer%2F", "customer="); }

        if (filter.includes("supplier=%2Fsupplier%2F")) { filter = filter.replace("supplier=%2Fsupplier%2F", "supplier="); }

        if (filter.includes("type=IMPORT%2CEXPORT")) { filter = filter.replace("type=IMPORT%2CEXPORT", "type=IMPORT&type=EXPORT"); }
        if (filter.includes("type=EXPORT%2CIMPORT")) { filter = filter.replace("type=EXPORT%2CIMPORT", "type=EXPORT&type=IMPORT"); }

        if (filter.includes("%2CTerrestre")) { filter = filter.replace("%2CTerrestre", "&via=Terrestre"); }

        if (filter.includes("%2CMaritima")) { filter = filter.replace("%2CMaritima", "&via=Maritima"); }

        if (filter.includes("%2CAerea")) { filter = filter.replace("%2CAerea", "&via=Aerea"); }

        if (filter.includes("ATS")) { filter = filter.replace("ATS", "&arrivalTimestamp="); }

        if (filter.includes("RPT")) { filter = filter.replace("RPT", "&requestingPaymentTimestamp="); }

        if (filter.includes("MayQ")) { filter = filter.replace("MayQ", "&customsValue="); }

        if (filter.includes("MenQ")) { filter = filter.replace("MenQ", "&customsValue="); }

        return (table.concat(filter).concat(projection));
    }

    formHandler(open, action, form) {
        switch (action) {
            case 'NEW_CUSTOMS_CLEARENCE':
                this.props.saveCustomsClearence(form, this.props.userData);
                break;
            case 'NEW_CUSTOMER':
                this.props.saveCustomer(form);
                break;
            case 'NEW_SUPPLIER':
                this.props.saveSupplier(form);
                break;
            default:
        }
    }

    render() {
        const { editing, DisableSave, errors } = this.state;
        const {
            customsClear,
            formOpen,
            conceptoOpen = false,
            isLoading,
            modalInfoState,
            formOpenNewCustomer = false,
            formOpenNewSupplier = false,
            customers = [],
            suppliers = [],
            customsClearences,
            statuses = [],
            customsHouses = { items: [] },
            customsHouses2 = { items: [] },
            preInvoices = [],
            customsHousesInLine,
            numPages,
            activePage,
            notify,
            executiveUsers,
            modalPrefacturaState,
            preInvoiceCreated,
            allowOnlyToModifyRequestPayment,
            userData,
            pagePermissions,
            allowAttachments,
            allowPreinvoice,
            allowReadPreinvoice,
            attachedFiles,
            snackbarConfig = { open: false, message: "Test", type: "black"}
        } = this.props;

            return (
            <div>
                <SubHeader
                    title="Despachos Aduaneros"
                    showRefresh={isLoading}
                    showAddButton={pagePermissions.create}
                    onPressHeaderButton={() => {
                        notify({ op: 'update', path: 'formOpen', value: true });
                    }}
                    paginationConfig={{
                        numPages,
                        activePage,
                        notify: (page) => {
                            const { fetchData, userData: { userId } } = this.props;
                            fetchData('despachos', 'customsClearences', 'customsClearences', { sort: 'arrivalTimestamp', projection: 'customsClearenceInLine', page, ['customer.executiveUser.id']: isExecutive() ? userId : '' });
                        }
                    }}
                />
                <div className="navbar visible-xs" style={{ padding: '0rem 2.3rem' }}>
                    <button
                        className="btn btn-default navbar-btn btn-filtros"
                        data-toggle="collapse" data-target="#filter-sidebar"
                    >
                        <i className="fa fa-tasks" /> Panel de filtros
                    </button>
                </div>
                <div>
                    <DespachosFilter
                        customsHouses={customsHouses && customsHouses.items}
                        onSearch={(params) => {
                            this.GotoSearch(params);
                        }}
                        onClear={(params) => {
                            const { fetchData, userData: { userId } } = this.props;
                            fetchData('despachos', 'customsClearences', 'customsClearences', { sort: 'arrivalTimestamp', projection: 'customsClearenceInLine', ['customer.executiveUser.id']: isExecutive() ? userId : '' });
                        }}
                    >
                        {
                            this.props.customsClearences.length === 0 ? <EmptyList /> :
                                this.props.customsClearences.map((customsClearence, index) => {
                                    //this.props.fetchAttachedFiles(customsClearence.folio);
                                    return (
                                        <Item
                                            key={index}
                                            customsClearenceProps={customsClearence}
                                            customsHouses={customsHouses}
                                            customers={customers}
                                            suppliers={suppliers}
                                            statuses={statuses}
                                            attachedFiles={attachedFiles}
                                            allowPreinvoice={allowPreinvoice}
                                            allowAttachments={allowAttachments}
                                            allowUpdate={pagePermissions.update}
                                            allowDelete={pagePermissions.delete}
                                            allowOnlyToModifyRequestPayment={allowOnlyToModifyRequestPayment}
                                            actions={{
                                                onAddClient: () => {
                                                    notify({ op: 'update', path: 'formOpenNewCustomer', value: true });
                                                },
                                                onAddSupplier: () => {
                                                    notify({ op: 'update', path: 'formOpenNewSupplier', value: true });
                                                },
                                                deleteCustomsClearence: (value) => {
                                                    this.props.deleteCustomsClearence(value);
                                                },
                                                getAttachedFiles: (folio) => {
                                                    this.props.fetchAttachedFiles('preInvoice', 'attachedFiles', 'preInvoices/attachmentsList?customsClearenceFolio='.concat(folio));
                                                },
                                                updateSnackBar: (message) => {
                                                  notify({
                                                      op: 'multiUpdate',
                                                      targets: [
                                                          { path: 'snackbarConfig>open', value: true },
                                                          { path: 'snackbarConfig>message', value: message },
                                                          { path: 'snackbarConfig>type', value: "red" }
                                                      ]
                                                  })
                                                }
                                            }}
                                            onOpenInfoModal={() => {
                                                actions.fetchUpdatedCustomClearenceArray( index, customsClearence.folio, { sort: 'arrivalTimestamp', projection: 'customsClearenceInLine' }).then( data =>
                                                  {
                                                    notify({ op: 'updateItem', path: 'customsClearences', value: { index, value:  { ...data._embedded.customsClearences[0]}}});
                                                    notify({ op: 'update', path: 'modalInfoState', value: { modalInfoOpen: true, customsClearence: data._embedded.customsClearences[0], index, statuses }})
                                                  });
                                                this.props.fetchPreinvoice('preInvoice', 'preInvoices', 'preInvoices/search/findByCustomsClearence?customsClearenceId='.concat(customsClearence.id));
                                                this.props.fetchAttachedFiles('preInvoice', 'attachedFiles', 'preInvoices/attachmentsList?customsClearenceFolio='.concat(customsClearence.folio));
                                            }}
                                            onOpenPrefacturaModal={() => {
                                                notify({
                                                    op: 'update',
                                                    path: 'modalPrefacturaState',
                                                    value: { open: true, customClearence: customsClearence, index, statuses }
                                                });
                                            }}
                                            onSave={(newCustomsClearence) => {
                                                //This is only updating the item on memory
                                                //Replace this with the action that saves results on server
                                                this.props.editCustomsClearence(statuses, newCustomsClearence, index);
                                            }}
                                        />
                                    );
                                })
                        }
                    </DespachosFilter>

                    {
                        <Info
                            modalInfoState={modalInfoState}
                            notify={notify}
                            customsHouses={customsHouses}
                            preInvoices={preInvoices}
                            allowAttachments={allowAttachments}
                            allowUpdate={pagePermissions.update}
                            allowOnlyToModifyRequestPayment={allowOnlyToModifyRequestPayment}
                            allowReadPreinvoice={allowReadPreinvoice}
                            attachedFiles={attachedFiles}
                            AuxActions={{
                                onSave: () => {
                                    this.props.editCustomsClearence(modalInfoState.statuses, modalInfoState.customsClearence, modalInfoState.index);
                                },
                                DeletedAttachedFiles: (value, folio) => {
                                    if (value.length > 0) {
                                        this.props.DeletedAttachedFiles(value, folio);
                                    } else {
                                    }
                                }
                            }}
                        />
                    }

                    {
                        !isEmpty(modalPrefacturaState.customClearence) &&
                        <Prefactura
                            open={modalPrefacturaState.open}
                            customClearence={modalPrefacturaState.customClearence}
                            customsHouses={customsHouses.items || []}
                            userData={userData}
                            onClose={() => {
                                notify({
                                    op: 'multiUpdate',
                                    targets: [
                                        { path: 'modalPrefacturaState', value: { open: false, customClearence: {} } },
                                        { path: 'preInvoiceCreated', value: {} },
                                    ]
                                })
                                this.props.fetchUpdatedCustomClearence('despachos', modalPrefacturaState.index, modalPrefacturaState.customClearence.id, modalPrefacturaState.customClearence.folio, 'customsClearences', { sort: 'arrivalTimestamp', projection: 'customsClearenceInLine' });
                            }}
                            onSave={(preInvoice) => this.props.savePreInvoice(preInvoice)}
                            preInvoiceCreated={preInvoiceCreated}
                            isLoading={isLoading}
                        />
                    }

                    {
                    this.props.snackbarConfig != undefined ?
                    <Snackbar
                        bodyStyle={{
                            top: 0,
                            bottom: 'auto',
                            backgroundColor: snackbarConfig.type,
                            maxWidth: "800px",
                            height: "55px",
                            lineHeight: "28px",
                            left: (window.innerWidth - 288) / 2,
                            /*transform: this.props.errorMessage ?
                              'translate3d(0, 0, 0)' :
                              "translate3d(0, "+ -(window.innerHeight - 100) + "px , 0)"*/
                        }}
                        open={snackbarConfig.open}
                        message={snackbarConfig.message}
                        autoHideDuration={4000}
                        onRequestClose={() => this.props.notify({ op: 'update', path: 'snackbarConfig>open', value: false })}
                    /> : null
                    }


                    <Form
                        title="Nuevo Despacho"
                        type="despacho"
                        open={formOpen}
                        actions={{
                            onAddClient: () => {
                                notify({ op: 'update', path: 'formOpenNewCustomer', value: true });
                            },
                            onAddSupplier: () => {
                                notify({ op: 'update', path: 'formOpenNewSupplier', value: true });
                            }
                        }}
                        params={{ customsHousesList: customsHouses, statuses: statuses }}
                        onModalClosed={() => { notify({ op: 'update', path: 'formOpen', value: false }) }}
                        onSave={(form) => {
                            this.formHandler(false, 'NEW_CUSTOMS_CLEARENCE', form);
                        }}//Will return if form is valid to send it
                    />

                    <Form
                        title="Nuevo Cliente"
                        type="cliente"
                        open={formOpenNewCustomer}
                        actions={{}}
                        params={{ executiveUsers: this.props.executiveUsers }}
                        onModalClosed={() => { notify({ op: 'update', path: 'formOpenNewCustomer', value: false }) }}
                        onSave={(form) => {
                            this.formHandler(true, 'NEW_CUSTOMER', form);
                        }}//Will return if form is valid to send it
                    />

                    <Form
                        title="Nuevo Proveedor"
                        type="proveedor"
                        open={formOpenNewSupplier}
                        actions={{}}
                        params
                        onModalClosed={() => { notify({ op: 'update', path: 'formOpenNewSupplier', value: false }) }}
                        onSave={(form) => {
                            this.formHandler(true, 'NEW_SUPPLIER', form);
                        }}//Will return if form is valid to send it
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ customesClearenceState, userData, userData: { permissions }, globalData }) => {
    return {
        ...customesClearenceState,
        userData,
        globalData,
        pagePermissions: getPagePermissions(CUSTOMS_CLEARENCE_PERMISSION, permissions),
        allowOnlyToModifyRequestPayment: hasUpdatePermission(REQUESTING_PAYMENT_PERMISSION, permissions),
        allowAttachments: hasCreatePermission(ATTACHMENTS_PERMISSION, permissions),
        allowPreinvoice: hasCreatePermission(PRE_INVOICE_PERMISSION, permissions),
        allowReadPreinvoice: hasReadPermission(PRE_INVOICE_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Despachos);



// WEBPACK FOOTER //
// ./containers/despachos/index.js